import {useMarkToolbarButton, useMarkToolbarButtonState} from "@udecode/plate/react";
import {ButtonWrapper} from "./_Button";
import {ReactNode} from "react";

export const MarkButton = (props: {
    format: string,
    children: ReactNode,
    [key: string]: any,
}) => {
    const { format, children, ...restProps } = props;
    const buttonState = useMarkToolbarButtonState({nodeType: format, clear: []});
    const buttonProps = useMarkToolbarButton(buttonState);

    return (
        <ButtonWrapper {...restProps} {...buttonProps.props}>
            {children}
        </ButtonWrapper>
    );
};